import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import StrUtils from '@/utils/StrUtils'

import { cache, cacheName } from '@/utils/cacheManager'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import $store from '@/store'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { Company } from '@/class/model/mdm/Company'
import { Job } from '@/class/model/booking/Job'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { SeaImCargoDoc } from '../../../model/booking/SeaImCargoDoc'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import * as NumberUtils from '@/utils/NumberUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import lang from '@/lang'
import { Message } from '@/utils/Message'
import { getExChangeAgent } from '@/api/partner/overseaAgent'
import { Office } from '@/class/model/sys/Office'
import { getLoading } from '@/utils/utilBaseElement'
import { queryPaymentAddressFunc } from '@/api/partner/mailingAddress'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { CargoDoc } from '@/class/model/booking/CargoDoc'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'

export class CargoDocUtil {
  static currentJob = null

  /**
   * 创建AMS
   */
  static async addAMS(job, isCreate = false) {
    const hbl = await new SeaExportJob(job).getMainHbl()
    return await this.addAmsByHbl(job, isCreate, hbl)
  }
  static async addAmsByHbl(job, isCreate = false, hbl) {
    let amsCargoDoc = await new SeaExportJob(job).getCargoDocByType(CargoDocConsts.AMS, false)
    if (amsCargoDoc || isCreate) {
      amsCargoDoc = await DocCommon.newCargoDoc(job)
      amsCargoDoc.docType = CargoDocConsts.AMS
      if (hbl && !StrUtils.isEmpty(hbl.hblNbr2)) {
        amsCargoDoc.hblNbr2 = hbl.hblNbr2// getAMSNbr(hbl,_model)
      } else {
        amsCargoDoc.hblNbr2 = job.jobNo// +"-"+(_model.cargoDoc.length + 1)
      }
      amsCargoDoc.hblNo = job.hblNo
      const containerLoadTypes = ['FCL', 'SPA', 'BCF']
      amsCargoDoc.containerLoadType = containerLoadTypes.includes(job.containerLoadType) ? 'FCL' : 'LCL'
      const hasDischargingPort = job.transfering && !StrUtils.isEmpty(job.transferPortCode) // 中转港是否不为空
      const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
      // 反恐舱单页签 County Of Origin 取值 基本-起运港
      const jobLoadingPorts = seaPorts.filter(p => p.code === job.loadingPortCode)
      if (jobLoadingPorts.length > 0) {
        amsCargoDoc.countryOrigin = jobLoadingPorts[0].countryCode
      }
      if (hasDischargingPort) {
        const ports = seaPorts.filter(p => p.code === job.transferPortCode)
        if (ports.length > 0) {
          amsCargoDoc.loadingPort = ports[0].englishName
          amsCargoDoc.lastAbroadProdName = ports[0].englishName
        }
        amsCargoDoc.loadingPortCode = job.transferPortCode
        amsCargoDoc.lastAbroadProd = job.transferPortCode
      } else {
        amsCargoDoc.lastAbroadProd = amsCargoDoc.loadingPortCode
        amsCargoDoc.lastAbroadProdName = amsCargoDoc.loadingPort
        if (hbl && job.signHBL) {
          amsCargoDoc.loadingPortCode = hbl.loadingPortCode // 提单起运港
          amsCargoDoc.loadingPort = hbl.loadingPort // 提单起运港
          amsCargoDoc.lastAbroadProd = hbl.loadingPortCode // 提单起运港
          amsCargoDoc.lastAbroadProdName = hbl.loadingPort // 提单起运港
        }
      }
      if (hbl && job.signHBL) {
        amsCargoDoc.dischargingPortCode = hbl.dischargingPortCode // 提单卸货港
        amsCargoDoc.dischargingPort = hbl.dischargingPort // 提单卸货港
        // 当HBL填写了“提单最终目的地”时，反恐舱单里的“Place of Delivery"取”提单最终目的地“的值，填入到文本框中，选择器内容为空
        if (!StrUtils.isEmpty(hbl.destinationPlace)) {
          amsCargoDoc.destinationPortCode = '' // 提单目的港
          amsCargoDoc.destinationPort = hbl.destinationPlace // 提单目的地
        } else {
          amsCargoDoc.destinationPortCode = hbl.destinationPortCode // 提单目的港
          amsCargoDoc.destinationPort = hbl.destinationPort // 提单目的港
        }
        if (hbl.dispatchingPlaceCode) {
          amsCargoDoc.dispatchingPlaceCode = hbl.dispatchingPlaceCode // 提单发货地
          amsCargoDoc.dispatchingPlace = hbl.dispatchingPlace // 提单发货地
        }
      }
      amsCargoDoc.firstPortOfCallCode = amsCargoDoc.dischargingPortCode // 第一个停靠港
      amsCargoDoc.firstPortOfCall = amsCargoDoc.dischargingPort // 第一个停靠港
      // 如果 提单发货地为空，则取基本页签的起运港
      if (!amsCargoDoc.dispatchingPlaceCode) {
        amsCargoDoc.dispatchingPlaceCode = job.loadingPortCode
        amsCargoDoc.dispatchingPlace = jobLoadingPorts.length > 0 ? jobLoadingPorts[0].englishName : ''
      }
      this.addAfrAddress(amsCargoDoc, hbl)
      amsCargoDoc.vessel = hasDischargingPort ? job.secondVesselVoyage : job.vessel
      const voyage = hasDischargingPort ? job.secondVoyage : job.voyageFlight
      amsCargoDoc.voyageFlight = this.replaceVoyage(voyage, true)

      // CARGO-32896 整拼类型=自拼箱，每个小票【反恐仓单-MB/L NO】改为取值【主单 -MB/L NO.】
      this.syncMblNo(amsCargoDoc, job)

      amsCargoDoc.hsCode = job.hsCode
      // 包装
      amsCargoDoc.packing = job.packing
      amsCargoDoc.vesselIMO = hasDischargingPort ? (StrUtils.isEmpty(amsCargoDoc.vessel) ? '' : ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Vessel, 'englishName', amsCargoDoc.vessel, 'imoCode')) : job.vesselIMO
      amsCargoDoc.eta = job.eta
      amsCargoDoc.etd = job.etd
      amsCargoDoc.releaseType = 1
      amsCargoDoc.state = 1
      if (hbl && job.signHBL) {
        amsCargoDoc.quantity = hbl.quantity
        amsCargoDoc.weight = hbl.weight
        amsCargoDoc.cubage = hbl.cubage
        amsCargoDoc.mark = hbl.mark
        amsCargoDoc.cargoEnglishName = hbl.cargoEnglishName
      } else {
        amsCargoDoc.quantity = job.quantityActual
        amsCargoDoc.weight = job.weightActual
        amsCargoDoc.cubage = job.cubageActual
        amsCargoDoc.mark = job.mark
        amsCargoDoc.cargoEnglishName = job.cargoEnglishName
      }
      this.copyBasicShipper(amsCargoDoc, job)
      this.copyBasicConsignee(amsCargoDoc, job)
      this.copyBasicNotify(amsCargoDoc, job)

      // CARGO-33651 利通 反恐舱单-企泰报文取值修改
      CargoDocUtil.syncFreightTermForAms(amsCargoDoc, hbl)
      //
      await this.fillNvoccScacAndEfNvoccScac(amsCargoDoc)
    }
    return amsCargoDoc
  }
  /**
   * 创建AFR
   */
  static async addAFR(job, isCreate = false) {
    const hbl = await new SeaExportJob(job).getMainHbl()
    return await this.addAfrByHbl(job, isCreate, hbl)
  }
  static async addAfrByHbl(job, isCreate = false, hbl) {
    let afrCargoDoc = await new SeaExportJob(job).getCargoDocByType(CargoDocConsts.AFR, false)
    if (afrCargoDoc || isCreate) {
      afrCargoDoc = await DocCommon.newCargoDoc(job)
      afrCargoDoc.docType = CargoDocConsts.AFR
      if (hbl && !StrUtils.isEmpty(hbl.hblNbr2)) {
        afrCargoDoc.hblNbr2 = hbl.hblNbr2// getAMSNbr(hbl,_model)
      } else {
        afrCargoDoc.hblNbr2 = job.jobNo// +"-"+(_model.cargoDoc.length + 1)
      }
      afrCargoDoc.hblNo = job.hblNo
      const containerLoadTypes = ['FCL', 'SPA', 'BCF']
      afrCargoDoc.containerLoadType = containerLoadTypes.includes(job.containerLoadType) ? 'FCL' : 'LCL'
      const hasDischargingPort = job.transfering && !StrUtils.isEmpty(job.transferPortCode) // 中转港是否不为空
      // 反恐舱单页签 County Of Origin 取值 基本-起运港
      const jobLoadingPorts = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', job.loadingPortCode)
      if (jobLoadingPorts) {
        afrCargoDoc.countryOrigin = jobLoadingPorts.countryCode
      }
      if (hasDischargingPort) {
        const ports = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', job.transferPortCode)
        if (ports) {
          afrCargoDoc.loadingPort = ports.englishName
          afrCargoDoc.lastAbroadProdName = ports.englishName
        }
        afrCargoDoc.loadingPortCode = job.transferPortCode
        afrCargoDoc.lastAbroadProd = job.transferPortCode
      } else {
        afrCargoDoc.lastAbroadProd = afrCargoDoc.loadingPortCode
        afrCargoDoc.lastAbroadProdName = afrCargoDoc.loadingPort
        if (hbl && job.signHBL) {
          afrCargoDoc.loadingPortCode = hbl.loadingPortCode // 提单起运港
          afrCargoDoc.loadingPort = hbl.loadingPort // 提单起运港
          afrCargoDoc.lastAbroadProd = hbl.loadingPortCode // 提单起运港
          afrCargoDoc.lastAbroadProdName = hbl.loadingPort // 提单起运港
        }
      }
      if (hbl && job.signHBL) {
        afrCargoDoc.dischargingPortCode = hbl.dischargingPortCode // 提单卸货港
        afrCargoDoc.dischargingPort = hbl.dischargingPort // 提单卸货港
        // 当HBL填写了“提单最终目的地”时，反恐舱单里的“Place of Delivery"取”提单最终目的地“的值，填入到文本框中，选择器内容为空
        if (!StrUtils.isEmpty(hbl.destinationPlace)) {
          afrCargoDoc.destinationPortCode = '' // 提单目的港
          afrCargoDoc.destinationPort = hbl.destinationPlace // 提单目的地
        } else {
          afrCargoDoc.destinationPortCode = hbl.destinationPortCode // 提单目的港
          afrCargoDoc.destinationPort = hbl.destinationPort // 提单目的港
        }
        if (hbl.dispatchingPlaceCode) {
          afrCargoDoc.dispatchingPlaceCode = hbl.dispatchingPlaceCode // 提单发货地
          afrCargoDoc.dispatchingPlace = hbl.dispatchingPlace // 提单发货地
        }
        if (hbl.hsCode) {
          afrCargoDoc.hsCode = hbl.hsCode
          if (afrCargoDoc.hsCode && afrCargoDoc.hsCode.length > 6) {
            afrCargoDoc.hsCode = afrCargoDoc.hsCode.substring(0, 6)
          }
        }
      }
      if (!afrCargoDoc.hsCode) {
        afrCargoDoc.hsCode = job.hsCode
        if (afrCargoDoc.hsCode && afrCargoDoc.hsCode.length > 6) {
          afrCargoDoc.hsCode = afrCargoDoc.hsCode.substring(0, 6)
        }
      }
      // 如果 提单发货地为空，则取基本页签的起运港
      if (!afrCargoDoc.dispatchingPlaceCode) {
        afrCargoDoc.dispatchingPlaceCode = job.loadingPortCode
        afrCargoDoc.dispatchingPlace = jobLoadingPorts ? jobLoadingPorts.englishName : ''
      }
      this.addAfrAddress(afrCargoDoc, hbl)
      afrCargoDoc.vessel = hasDischargingPort ? job.secondVesselVoyage : job.vessel
      const voyage = hasDischargingPort ? job.secondVoyage : job.voyageFlight
      afrCargoDoc.voyageFlight = this.replaceVoyage(voyage, true)

      // CARGO-32896 整拼类型=自拼箱，每个小票【反恐仓单-MB/L NO】改为取值【主单 -MB/L NO.】
      this.syncMblNo(afrCargoDoc, job)
      // 包装
      afrCargoDoc.packing = job.packing
      afrCargoDoc.vesselIMO = hasDischargingPort ? (StrUtils.isEmpty(afrCargoDoc.vessel) ? '' : ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Vessel, 'englishName', afrCargoDoc.vessel, 'imoCode')) : job.vesselIMO
      afrCargoDoc.eta = job.eta
      afrCargoDoc.etd = job.etd
      afrCargoDoc.releaseType = 1
      afrCargoDoc.state = 1
      if (hbl && job.signHBL) {
        afrCargoDoc.quantity = hbl.quantity
        afrCargoDoc.weight = hbl.weight
        afrCargoDoc.cubage = hbl.cubage
        afrCargoDoc.mark = hbl.mark
        afrCargoDoc.cargoEnglishName = hbl.cargoEnglishName
      } else {
        afrCargoDoc.quantity = job.quantityActual
        afrCargoDoc.weight = job.weightActual
        afrCargoDoc.cubage = job.cubageActual
        afrCargoDoc.mark = job.mark
        afrCargoDoc.cargoEnglishName = job.cargoEnglishName
      }
      this.copyBasicShipper(afrCargoDoc, job)
      this.copyBasicConsignee(afrCargoDoc, job)
      this.copyBasicNotify(afrCargoDoc, job)
      await this.fillNvoccScacAndEfNvoccScac(afrCargoDoc)
    }
    return afrCargoDoc
  }
  static addAfrAddress(amsCargoDoc, cargoDoc) {
    amsCargoDoc.afrAddress = []
    const addressForm = new AfrAddress().fillDefaultValue().getData()
    if (cargoDoc) {
      this.copyAfrAddress(addressForm, cargoDoc)
    }
    amsCargoDoc.afrAddress.push(addressForm)
  }
  static copyAfrAddress(addressForm, cargoDoc) {
    // 同步按钮和新增按钮公用此方法逻辑
    this.copyCargoDocSft(addressForm, cargoDoc)
    addressForm.shipperTel = cargoDoc.shipperTel
    addressForm.consigneeTel = cargoDoc.consigneeTel
    addressForm.notifyTel = cargoDoc.notifyTel
  }

  /**
   * CARGO-33246 海出模块-反恐舱单页签，收发通第一行为空 ， 35字符限制等
   * 复制HBL收发通信息
   * @param addressForm
   * @param cargoDoc
   */
  static copyCargoDocSft(addressForm, cargoDoc) {
    if (!addressForm || !cargoDoc) return
    addressForm.shipperLine1 = cargoDoc.shipperLine1
    addressForm.shipperLine3 = cargoDoc.shipperLine2
    addressForm.shipperLine4 = cargoDoc.shipperLine3
    let shipperLine5 = cargoDoc.shipperLine4 || ''
    if (shipperLine5) shipperLine5 += '\n'
    if (cargoDoc.shipperLine5) shipperLine5 += cargoDoc.shipperLine5
    if (shipperLine5) shipperLine5 += '\n'
    if (cargoDoc.shipperLine6) shipperLine5 += cargoDoc.shipperLine6
    if (shipperLine5) shipperLine5 += '\n'
    if (cargoDoc.shipperLine7) shipperLine5 += cargoDoc.shipperLine7
    addressForm.shipperLine5 = shipperLine5

    addressForm.consigneeLine1 = cargoDoc.consigneeLine1
    addressForm.consigneeLine3 = cargoDoc.consigneeLine2
    addressForm.consigneeLine4 = cargoDoc.consigneeLine3
    let consigneeLine5 = cargoDoc.consigneeLine4 || ''
    if (consigneeLine5) consigneeLine5 += '\n'
    if (cargoDoc.consigneeLine5) consigneeLine5 += cargoDoc.consigneeLine5
    if (consigneeLine5) consigneeLine5 += '\n'
    if (cargoDoc.consigneeLine6) consigneeLine5 += cargoDoc.consigneeLine6
    if (consigneeLine5) consigneeLine5 += '\n'
    if (cargoDoc.consigneeLine7) consigneeLine5 += cargoDoc.consigneeLine7
    addressForm.consigneeLine5 = consigneeLine5

    addressForm.notifyLine1 = cargoDoc.notifyLine1
    addressForm.notifyLine3 = cargoDoc.notifyLine2
    addressForm.notifyLine4 = cargoDoc.notifyLine3
    let notifyLine5 = cargoDoc.notifyLine4 || ''
    if (notifyLine5) notifyLine5 += '\n'
    if (cargoDoc.notifyLine5) notifyLine5 += cargoDoc.notifyLine5
    if (notifyLine5) notifyLine5 += '\n'
    if (cargoDoc.notifyLine6) notifyLine5 += cargoDoc.notifyLine6
    if (notifyLine5) notifyLine5 += '\n'
    if (cargoDoc.notifyLine7) notifyLine5 += cargoDoc.notifyLine7
    addressForm.notifyLine5 = notifyLine5
  }
  // index为0时取前35个字符，非0时取第35个后的字符
  static getAfrAddressLine(line, index) {
    if (!line || line.trim() === '') {
      return ''
    }
    // 最大字符长度
    const MAX_CHART = 35
    if (index === 0) {
      return line.substr(0, MAX_CHART)
    } else {
      if (line.length > MAX_CHART) {
        return line.substr(MAX_CHART, line.length)
      }
    }
    return ''
  }
  static getMainAms(create = false) {
    this.getCargoDoc('AMS', create)
  }
  static getCargoDoc(type, create = false) {
    if (this.cargoDoc === null && !create) {
      return null
    }
    if (!create) return null
    return SeaCargoDoc.newCargoDoc(this, type)
  }
  static getMainHbl(isCreate) {
    this.getCargoDoc('HBL', isCreate)
  }

  /** *
   * 提单件毛体与job同步方式
   * 0 不同步 1 单向同步（job同步至提单） 2 双向同步 3 ，仅件毛体单向同步（job同步至提单) ：4 ，仅件毛体单向同步（提单同步至job)
   * 只与非拆并单提单同步
   */
  static async changeSynBillOfLadingQWC(job, quantityActual = 0.0, weightActual = 0.0, cubageActual = 0.0) {
    if (quantityActual > 0) {
      job.quantityActual = NumberUtils.ToFixed2(quantityActual, 2)
    }
    if (weightActual > 0) {
      job.weightActual = NumberUtils.ToFixed2(weightActual, 3)
    }
    if (cubageActual > 0) {
      job.cubageActual = NumberUtils.ToFixed2(cubageActual, 3)
    }
    let mblDoc = null
    let hblDoc = null
    if (job.seaCargoDoc && job.seaCargoDoc.length > 0) {
      for (const cargoDoc of job.seaCargoDoc) {
        if (cargoDoc.docType === CargoDocConsts.MBL) {
          mblDoc = cargoDoc
          break
        }
      }
      for (const cargoDoc of job.seaCargoDoc) {
        if (cargoDoc.docType === CargoDocConsts.HBL) {
          hblDoc = cargoDoc
          break
        }
      }
    }
    if (!mblDoc) {
      mblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.MBL, false)
    }
    if (!hblDoc) {
      hblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.HBL, false)
    }
    if (mblDoc) {
      this.changeJobSynToBillOfLading(job, mblDoc)
    }
    if (hblDoc) {
      this.changeJobSynToBillOfLading(job, hblDoc)
    }
  }

  /**
   * Job同步至提单
   */
  static changeJobSynToBillOfLading(job, cargoDoc) {
    if (!job || !cargoDoc) return
    const billOfLadingSynMode = parseInt(cache.config.get('BillOfLadingSynMode'))
    if ([1, 2, 3].includes(billOfLadingSynMode)) {
      cargoDoc.quantity = job.quantityActual
      cargoDoc.weight = job.weightActual
      cargoDoc.cubage = job.cubageActual
      cargoDoc.chargeWeight = job.chargeWeight
      if (billOfLadingSynMode !== 3) {
        cargoDoc.packing = job.packing
        const packing = getObjectByCache(TYPE_NAMES.basic_data_Packing, 'code', job.packing)
        cargoDoc.packingName = packing ? packing.name : '' // 包装显示名
      }
    }
  }

  /**
   * HBL计费重量修改计算 - 海出
   */
  static calculateSEChargeWeight(cargoDoc) {
    let weight = cargoDoc.weight
    const cubage = cargoDoc.cubage
    if (isNaN(weight) || isNaN(cubage)) return
    weight = weight / 1000
    if (cubage > weight) {
      weight = cubage
    }
    if (weight > 0 && weight < 1) {
      weight = 1.00
    }
    cargoDoc.chargeWeight = parseFloat(weight.toFixed(3))
  }

  /**
   * PILL-1056 同步逻辑优化
   */
  static syncContainerHandle(vm, job, cargoDoc, syncContainerInfoDialog) {
    const params = {}
    params.quantityArray = [cargoDoc.quantity, 0]
    params.weightArray = [cargoDoc.weight, 0]
    params.cubageArray = [cargoDoc.cubage, 0]
    params.cargoDoc = cargoDoc
    // 拆并单取不同过的信息进行处理
    if (job.typeMBL === BillType.NORMAL_BILL_TYPE.code) {
      if (job.containerUsages) {
        CargoDocUtil.fillTotalQuantityAndWeightAndCubageByContainerInfo(params, job.containerUsages)
        syncContainerInfoDialog.visible = true
        vm.$refs.syncContainerInfoDialog.initInfo(params)
      }
    } else if (job.typeMBL === BillType.MERGE_BILL_TYPE.code || job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
      if (cargoDoc.ediContainer) {
        // 存在删除的情况，删除时deleted为true
        const filteredEdiContainer = cargoDoc.ediContainer.filter(item => !item.deleted)
        CargoDocUtil.fillTotalQuantityAndWeightAndCubageByContainerInfo(params, filteredEdiContainer)
        syncContainerInfoDialog.visible = true
        vm.$refs.syncContainerInfoDialog.initInfo(params)
      }
    }
  }

  static fillTotalQuantityAndWeightAndCubageByContainerInfo(params, containerArray) {
    // 件
    const qualityTotal = containerArray.reduce((total, item) => {
      return total + Number(item.quantity)
    }, 0)
    params.quantityArray[1] = NumberUtils.roundHalfUp3(qualityTotal, 0)
    // 毛
    const weightTotal = containerArray.reduce((total, item) => {
      return total + Number(item.weight)
    }, 0)
    params.weightArray[1] = NumberUtils.roundHalfUp3(weightTotal, 3)
    // 体
    const cubageTotal = containerArray.reduce((total, item) => {
      return total + Number(item.cubage)
    }, 0)
    params.cubageArray[1] = NumberUtils.roundHalfUp3(cubageTotal, 3)
  }
  /**
   * HBL计费重量修改计算 - 海进
   */
  static calculateSIChargeWeight(cargoDoc) {
    const chargeWeight = cargoDoc.weight / 1000

    // 毛重或体积未填写时
    if (isNaN(cargoDoc.cubage) && isNaN(cargoDoc.weight)) {
      cargoDoc.chargeWeight = 0
      return
    }
    if (isNaN(cargoDoc.cubage)) {
      cargoDoc.chargeWeight = chargeWeight
      return
    }
    if (isNaN(cargoDoc.weight)) {
      cargoDoc.chargeWeight = cargoDoc.cubage
      return
    }

    if (chargeWeight > cargoDoc.cubage) {
      cargoDoc.chargeWeight = chargeWeight
    } else {
      cargoDoc.chargeWeight = cargoDoc.cubage
    }
  }

  /** *
   * 提单同步至Job
   */
  static async changeBillOfLadingSynJob(job, cargoDoc, needUpdateUsage = false) {
    if (!job || !cargoDoc) return
    const billOfLadingSynMode = parseInt(cache.config.get('BillOfLadingSynMode'))
    const rule = parseInt(cache.config.get('SEQuantityWeightCubageRule'))
    if ([2, 4].includes(billOfLadingSynMode)) {
      job.quantityActual = cargoDoc.quantity
      job.weightActual = cargoDoc.weight
      job.cubageActual = cargoDoc.cubage
      job.chargeWeight = cargoDoc.chargeWeight
      if (billOfLadingSynMode !== 4) {
        job.packing = cargoDoc.packing
        const packing = getObjectByCache(TYPE_NAMES.basic_data_Packing, 'code', job.packing)
        cargoDoc.packingName = packing ? packing.name : '' // 包装显示名
      }
      if (rule === 2) {
        job.quantityContract = job.quantityActual
        job.weightContract = job.weightActual
        job.cubageContract = job.cubageActual
      }
      const expression = parseInt(cache.config.get('ContainerUpdateJobQCW'))
      if (String(cache.config.get('ToExoSystem')) === 'XYCW' && needUpdateUsage && expression === 3 && billOfLadingSynMode === 2 && job.lob === SystemConstants.SE.code && [CargoDocConsts.HBL, CargoDocConsts.MBL].includes(cargoDoc.docType)) {
        await new SeaExportJob(job).getContainerUsages()
        if (job.containerUsages && job.containerUsages.length === 1) {
          const usage = job.containerUsages[0]
          if (usage) {
            ContainerUtil.containerJobSynQwc(job, usage, true)
          }
        }
      }
      await this.changeBillOfLadingSynDoc(cargoDoc, job, billOfLadingSynMode === 4 ? ['quantity', 'weight', 'cubage', 'chargeWeight'] : ['quantity', 'weight', 'cubage', 'chargeWeight', 'packing'])
    }
  }

  /**
   * MBL/HBL相互同步
   * @param cargoDoc
   * @param job
   * @param fields 同步字段
   * @returns {Promise<void>}
   */
  static async changeBillOfLadingSynDoc(cargoDoc, job, fields, syncJob = false) {
    if (syncJob) { // 同步至基本页签
      for (const field of fields) {
        job[field] = cargoDoc[field]
      }
    }
    let docType = ''
    if (cargoDoc.docType === CargoDocConsts.MBL) {
      docType = CargoDocConsts.HBL
    }
    if (cargoDoc.docType === CargoDocConsts.HBL) {
      docType = CargoDocConsts.MBL
    }
    // 同步到MBL/HBL
    if (docType) {
      let doc = null
      if (job.lob === 'SE') {
        doc = await new SeaExportJob(job).getCargoDocByDocType(docType, false)
      }
      if (job.lob === 'SI') {
        doc = await new SeaImportJob(job).getCargoDocByDocType(docType, false)
      }
      if (doc) {
        // 如果是HBL,且HBL已锁定时，不同步
        if (docType === CargoDocConsts.HBL && doc.state === 2) {
          return
        }
        for (const field of fields) {
          doc[field] = cargoDoc[field]
        }
      }
    }
  }

  /**
   * 收发通地址录入的超过最大字符自动换行
   */
  static sftAddrChangeWrap(target, source, maxChars) {
    if (target.length >= maxChars) {
      const strat = target.lastIndexOf(' ')
      const end = target.length
      source = target.slice(strat + 1, end)
      target = target.slice(0, strat)
      // source.selectRange(source.length, source.length)
    }
  }

  /**
   * 收发通地址录入的超过最大字符自动换行
   */
  static sftAddrInputWrap(source, from, to, maxChars) {
    const sourceField = source[from]
    if (maxChars && sourceField.length > maxChars) {
      if (to) {
        const tp = String(cache.config.get('ToExoSystem')) === 'TP'
        const lastIndexOfSpace = sourceField.lastIndexOf(' ', maxChars)
        let wrapIndex = lastIndexOfSpace > 0 ? lastIndexOfSpace : maxChars
        const wrapCharIndex = sourceField.indexOf('\n')
        if (wrapCharIndex !== -1 && wrapCharIndex < maxChars) {
          wrapIndex = wrapCharIndex
        }
        source[from] = sourceField.slice(0, wrapIndex)
        const n = to.slice(-1)
        // 如果是太平的 ，并且不是最后一行
        if (tp && n !== 7) {
          const newData = sourceField.slice(wrapIndex).trim()
          CargoDocUtil.calculateData(source, to, newData, n)
        } else {
          source[to] = source[to] ? sourceField.slice(wrapIndex).trim() + '\n' + source[to] : sourceField.slice(wrapIndex).trim()
        }
        this.$refs[to][0].$refs.cargoInput.focus()
      }
    }
  }

  static onClear(form, type, detail) {
    switch (type) {
      case 1:
        form.shipperCode = ''
        form.shipperLine1 = ''
        form.shipperLine2 = ''
        form.shipperLine3 = ''
        if (detail) {
          form.shipperCountry = ''
          form.shipperCity = ''
          form.shipperProvince = ''
          form.shipperZipCode = ''
          form.shipperMobile = ''
          form.shipperEmail = ''
          form.shipperFax = ''
          form.shipperContact = ''
        } else {
          form.shipperLine4 = ''
          form.shipperLine5 = ''
          form.shipperLine6 = ''
          form.shipperLine7 = ''
        }
        break
      case 2:
        form.consigneeCode = ''
        form.consigneeLine1 = ''
        form.consigneeLine2 = ''
        form.consigneeLine3 = ''
        if (detail) {
          form.consigneeCountry = ''
          form.consigneeCity = ''
          form.consigneeProvince = ''
          form.consigneeZipCode = ''
          form.consigneeMobile = ''
          form.consigneeEmail = ''
          form.consigneeFax = ''
          form.consigneeContact = ''
        } else {
          form.consigneeLine4 = ''
          form.consigneeLine5 = ''
          form.consigneeLine6 = ''
          form.consigneeLine7 = ''
        }
        break
      case 3:
        form.notifyCode = ''
        form.notifyLine1 = ''
        form.notifyLine2 = ''
        form.notifyLine3 = ''
        if (detail) {
          form.notifyCountry = ''
          form.notifyCity = ''
          form.notifyProvince = ''
          form.notifyZipCode = ''
          form.notifyMobile = ''
          form.notifyEmail = ''
          form.notifyFax = ''
          form.notifyContact = ''
        } else {
          form.notifyLine4 = ''
          form.notifyLine5 = ''
          form.notifyLine6 = ''
          form.notifyLine7 = ''
        }
        break
      default:
        break
    }
  }
  static applyNotifyManifestAddress(form, company, isDetail) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      form.notifyCode = company.englishName
      if (isDetail) {
        form.notifyLine1 = manifestaddress.enterpriseName
        form.notifyLine2 = manifestaddress.address
        form.notifyLine3 = ''
        form.notifyCountry = manifestaddress.countryCode // 国家
        form.notifyCity = manifestaddress.cityName // 城市
        form.notifyProvince = manifestaddress.provinceName // 省
        form.notifyZipCode = manifestaddress.zipCode // 邮编
        switch (manifestaddress.contactsType) {
          case 0:
            form.notifyMobile = manifestaddress.contacts
            form.notifyEmail = ''
            form.notifyFax = ''
            break
          case 1:
            form.notifyMobile = ''
            form.notifyEmail = manifestaddress.contacts
            form.notifyFax = ''
            break
          case 2:
            form.notifyMobile = ''
            form.notifyEmail = ''
            form.notifyFax = manifestaddress.contacts
            break
        }
        form.notifyContact = manifestaddress.specificContactsName
        const address = manifestaddress.countryCode + manifestaddress.address + manifestaddress.countryCode + manifestaddress.cityName + manifestaddress.provinceName +
            manifestaddress.zipCode + manifestaddress.contacts + manifestaddress.specificContactsName
        // 详细信息没维护带人前三行
        if (address.length === 0) {
          form.notifyLine1 = manifestaddress.addressLine1
          form.notifyLine2 = manifestaddress.addressLine2
          form.notifyLine3 = manifestaddress.addressLine3
        }
      } else {
        form.notifyLine1 = manifestaddress.addressLine1
        form.notifyLine2 = manifestaddress.addressLine2
        form.notifyLine3 = manifestaddress.addressLine3
        form.notifyLine4 = manifestaddress.addressLine4
        form.notifyLine5 = manifestaddress.addressLine5
        form.notifyLine6 = manifestaddress.addressLine6
        form.notifyLine7 = manifestaddress.addressLine7
        const address = manifestaddress.addressLine1 + manifestaddress.addressLine2 + manifestaddress.addressLine3 +
            manifestaddress.addressLine4 + manifestaddress.addressLine5 + manifestaddress.addressLine6 + manifestaddress.addressLine7
        // 地址没维护 带入地址和城市
        if (address.length === 0) {
          form.notifyLine1 = manifestaddress.enterpriseName
          form.notifyLine2 = manifestaddress.address
        }
      }
    } else {
      form.notifyCode = ''
      form.notifyLine1 = ''
      form.notifyLine2 = ''
      form.notifyLine3 = ''
      if (isDetail) {
        form.notifyCountry = ''
        form.notifyCity = ''
        form.notifyProvince = ''
        form.notifyZipCode = ''
        form.notifyMobile = ''
        form.notifyEmail = ''
        form.notifyFax = ''
        form.notifyContact = ''
      } else {
        form.notifyLine4 = ''
        form.notifyLine5 = ''
        form.notifyLine6 = ''
        form.notifyLine7 = ''
      }
    }
  }
  static applyConsigneeManifestAddress(form, company, isDetail) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      form.consigneeCode = company.englishName
      if (isDetail) {
        form.consigneeLine1 = manifestaddress.enterpriseName
        form.consigneeLine2 = manifestaddress.address
        form.consigneeLine3 = ''
        form.consigneeCountry = manifestaddress.countryCode // 国家
        form.consigneeCity = manifestaddress.cityName // 城市
        form.consigneeProvince = manifestaddress.provinceName // 省
        form.consigneeZipCode = manifestaddress.zipCode // 邮编
        switch (manifestaddress.contactsType) {
          case 0:
            form.consigneeMobile = manifestaddress.contacts
            form.consigneeEmail = ''
            form.consigneeFax = ''
            break
          case 1:
            form.consigneeMobile = ''
            form.consigneeEmail = manifestaddress.contacts
            form.consigneeFax = ''
            break
          case 2:
            form.consigneeMobile = ''
            form.consigneeEmail = ''
            form.consigneeFax = manifestaddress.contacts
            break
        }
        form.consigneeContact = manifestaddress.specificContactsName // 联系人
        const address = manifestaddress.countryCode + manifestaddress.address + manifestaddress.countryCode + manifestaddress.cityName + manifestaddress.provinceName +
            manifestaddress.zipCode + manifestaddress.contacts + manifestaddress.specificContactsName
        // 详细信息没维护带人前三行
        if (address.length === 0) {
          form.consigneeLine1 = manifestaddress.addressLine1
          form.consigneeLine2 = manifestaddress.addressLine2
          form.consigneeLine3 = manifestaddress.addressLine3
        }
      } else {
        form.consigneeLine1 = manifestaddress.addressLine1
        form.consigneeLine2 = manifestaddress.addressLine2
        form.consigneeLine3 = manifestaddress.addressLine3
        form.consigneeLine4 = manifestaddress.addressLine4
        form.consigneeLine5 = manifestaddress.addressLine5
        form.consigneeLine6 = manifestaddress.addressLine6
        form.consigneeLine7 = manifestaddress.addressLine7
        const address = manifestaddress.addressLine1 + manifestaddress.addressLine2 + manifestaddress.addressLine3 +
            manifestaddress.addressLine4 + manifestaddress.addressLine5 + manifestaddress.addressLine6 + manifestaddress.addressLine7
        // 地址没维护 带入地址和城市
        if (address.length === 0) {
          form.consigneeLine1 = manifestaddress.enterpriseName
          form.consigneeLine2 = manifestaddress.address
        }
      }
    } else {
      form.consigneeCode = ''
      form.consigneeLine1 = ''
      form.consigneeLine2 = ''
      form.consigneeLine3 = ''
      if (isDetail) {
        form.consigneeCountry = ''
        form.consigneeCity = ''
        form.consigneeProvince = ''
        form.consigneeZipCode = ''
        form.consigneeMobile = ''
        form.consigneeEmail = ''
        form.consigneeFax = ''
        form.consigneeContact = ''
      } else {
        form.consigneeLine4 = ''
        form.consigneeLine5 = ''
        form.consigneeLine6 = ''
        form.consigneeLine7 = ''
      }
    }
  }
  static applyShipperManifestAddress(form, company, isDetail) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      form.shipperCode = company.englishName
      if (isDetail) {
        form.shipperLine1 = manifestaddress.enterpriseName
        form.shipperLine2 = manifestaddress.address
        form.shipperLine3 = ''
        form.shipperCountry = manifestaddress.countryCode // 国家
        form.shipperCity = manifestaddress.cityName // 城市
        form.shipperProvince = manifestaddress.provinceName // 省
        form.shipperZipCode = manifestaddress.zipCode // 邮编
        switch (manifestaddress.contactsType) {
          case 0:
            form.shipperMobile = manifestaddress.contacts
            form.shipperEmail = ''
            form.shipperFax = ''
            break
          case 1:
            form.shipperMobile = ''
            form.shipperEmail = manifestaddress.contacts
            form.shipperFax = ''
            break
          case 2:
            form.shipperMobile = ''
            form.shipperEmail = ''
            form.shipperFax = manifestaddress.contacts
            break
        }
        form.shipperContact = manifestaddress.specificContactsName // 联系人
        const address = manifestaddress.countryCode + manifestaddress.address + manifestaddress.countryCode + manifestaddress.cityName + manifestaddress.provinceName +
            manifestaddress.zipCode + manifestaddress.contacts + manifestaddress.specificContactsName
        // 详细信息没维护带人前三行
        if (address.length === 0) {
          form.shipperLine1 = manifestaddress.addressLine1
          form.shipperLine2 = manifestaddress.addressLine2
          form.shipperLine3 = manifestaddress.addressLine3
        }
      } else {
        form.shipperLine1 = manifestaddress.addressLine1
        form.shipperLine2 = manifestaddress.addressLine2
        form.shipperLine3 = manifestaddress.addressLine3
        form.shipperLine4 = manifestaddress.addressLine4
        form.shipperLine5 = manifestaddress.addressLine5
        form.shipperLine6 = manifestaddress.addressLine6
        form.shipperLine7 = manifestaddress.addressLine7
        const address = manifestaddress.addressLine1 + manifestaddress.addressLine2 + manifestaddress.addressLine3 +
            manifestaddress.addressLine4 + manifestaddress.addressLine5 + manifestaddress.addressLine6 + manifestaddress.addressLine7
        // 地址没维护 带入地址和城市
        if (address.length === 0) {
          form.shipperLine1 = manifestaddress.enterpriseName
          form.shipperLine2 = manifestaddress.address
        }
      }
    } else {
      form.shipperCode = ''
      form.shipperLine1 = ''
      form.shipperLine2 = ''
      form.shipperLine3 = ''
      if (isDetail) {
        form.shipperCountry = ''
        form.shipperCity = ''
        form.shipperProvince = ''
        form.shipperZipCode = ''
        form.shipperMobile = ''
        form.shipperEmail = ''
        form.shipperFax = ''
        form.shipperContact = ''
      } else {
        form.shipperLine4 = ''
        form.shipperLine5 = ''
        form.shipperLine6 = ''
        form.shipperLine7 = ''
      }
    }
  }

  static paymentImportData(form, type, lob = 'SE') {
    if (form.paymentCode) {
      this.loading = getLoading()
      const data = {
        paymentCode: form.paymentCode,
        lob: lob
      }
      queryPaymentAddressFunc(data).then((res) => {
        const add = res.data
        this.clearForm(form, type)
        if (!add) {
          return
        }
        // 在正常情况下
        if (type) {
          form.paymentLine1 = add.paymentLine1
          form.paymentLine2 = add.paymentLine2
          form.paymentLine3 = add.paymentLine3
          form.paymentLine4 = add.paymentLine4
          form.paymentLine5 = add.paymentLine5
          form.paymentLine6 = add.paymentLine6
          const address = add.paymentLine1 + add.paymentLine2 + add.paymentLine3 + add.paymentLine4 + add.paymentLine5 + add.paymentLine6
          // 地址没维护 带入地址和城市
          if (address.length === 0) {
            form.paymentLine1 = add.paymentCityName
            form.paymentLine2 = add.paymentAddress
          }
          form.paymentVipCode = add.paymentVipCode
          form.paymentMscCode = add.paymentMscCode
          form.paymentCompanyCode = add.paymentCompanyCode
          form.paymentInttraCode = add.paymentInttraCode
        } else {
          form.paymentLine1 = add.paymentCityName
          form.paymentLine2 = add.paymentAddress
          form.paymentLine3 = add.paymentStreetNo
          form.paymentCity = add.paymentCityName
          form.paymentProvince = add.paymentProvinceName
          form.paymentPostalCode = add.paymentZipCode
          switch (add.paymentContactsType) {
            case 0:
              form.paymentPhone = add.paymentContacts
              form.paymentEmail = ''
              form.paymentFax = ''
              break
            case 1:
              form.paymentPhone = ''
              form.paymentEmail = add.paymentContacts
              form.paymentFax = ''
              break
            case 2:
              form.paymentPhone = ''
              form.paymentEmail = ''
              form.paymentFax = add.paymentContacts
              break
          }
          form.paymentContact = add.paymentEnterpriseName
          const address = add.paymentCityName + add.paymentAddress + add.paymentStreetNo + add.paymentCityName +
              add.paymentProvinceName + add.paymentZipCode + add.paymentContacts + add.paymentEnterpriseName
          // 详细信息没维护带人前三行
          if (address.length === 0) {
            form.paymentLine1 = add.paymentLine1
            form.paymentLine2 = add.paymentLine2
            form.paymentLine3 = add.paymentLine3
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }

  static clearForm(form, type) {
    form.paymentLine1 = ''
    form.paymentLine2 = ''
    form.paymentLine3 = ''
    form.paymentLine7 = ''
    if (type) {
      form.paymentLine4 = ''
      form.paymentLine5 = ''
      form.paymentLine6 = ''
    } else {
      form.paymentCity = ''
      form.paymentProvince = ''
      form.paymentPostalCode = ''
      form.paymentPhone = ''
      form.paymentEmail = ''
      form.paymentContact = ''
      form.paymentFax = ''
    }
  }
  /**
   * 所有数据后退一行
   * @param source
   * @param to
   * @param newData
   * @param n
   */
  static calculateData(source, to, newData, n) {
    const nextN = Number(n) + 1
    const oldTo = source[to]
    // 将截取值更新在目标行
    source[to] = newData
    // 计算出下一行
    const data = to.slice(0, to.length - 1)
    const toNext = data + nextN
    if (nextN < 7) {
      this.calculateData(source, toNext, oldTo, nextN)
    } else {
      // 第七行 数据接在原数据前
      source[toNext] = source[toNext] ? oldTo + '\n' + source[toNext] : oldTo
    }
  }
  /**
   * 初始化新增MBL时的相关属性
   */
  static async initMBLProperties(mbl, job = null, action = '', isDo = false) {
    if (!job) return
    const office = $store.getters.currentOffice
    const key = 'COPY_MBL_' + job.lob
    if (!LocalStorageUtils.hasConfiguration(key) || Boolean(LocalStorageUtils.getConfiguration(key)) || !job.copyOnly) {
      const isGetOfficeShipper = (String(cache.config.get('ToExoSystem')) === 'XYCW') && action === 'copy'
      // 不是直单 MBL、发货人取当前公司海运提单地址；是直单，取基本信息里的
      if (office && job.lob !== 'SI' && (job.jobState !== -1 || isDo) && (action !== 'copy' || isGetOfficeShipper)) {
        if (StrUtils.isEmpty(mbl.shipperLine1)) {
          mbl.shipperLine1 = job.mblOnly ? job.shipperLine1 : office.seaAddressLine1
        }
        if (StrUtils.isEmpty(mbl.shipperLine2)) {
          mbl.shipperLine2 = job.mblOnly ? job.shipperLine2 : office.seaAddressLine2
        }
        if (StrUtils.isEmpty(mbl.shipperLine3)) {
          mbl.shipperLine3 = job.mblOnly ? job.shipperLine3 : office.seaAddressLine3
        }
        if (StrUtils.isEmpty(mbl.shipperLine4)) {
          mbl.shipperLine4 = job.mblOnly ? job.shipperLine4 : office.seaAddressLine4
        }
        if (StrUtils.isEmpty(mbl.shipperLine5)) {
          mbl.shipperLine5 = job.mblOnly ? job.shipperLine5 : office.seaAddressLine5
        }
        if (StrUtils.isEmpty(mbl.shipperLine6)) {
          mbl.shipperLine6 = job.mblOnly ? job.shipperLine6 : office.seaAddressLine6
        }
      }
      if (StrUtils.isEmpty(mbl.notifyLine1)) {
        mbl.notifyLine1 = 'SAME AS CONSIGNEE'
      }
    }
    if (!LocalStorageUtils.hasConfiguration(key) && !LocalStorageUtils.getConfiguration(key) && !job.copyOnly) {
      if (job.lob === 'SE') {
        await SeaCargoDoc.copyInfoFromSeaExportJob(job, mbl).then(r => {})
      }
      if (job.lob === 'SI') {
        await SeaImCargoDoc.copyInfoFromSeaImportJob(job, mbl)
      }
    }
  }

  static async initMBLProperties2(mbl, job = null) {
    if (!job) return
    const office = $store.getters.currentOffice
    const key = 'COPY_MBL_' + job.lob
    // 不是直单 MBL、发货人取当前公司海运提单地址；是直单，取基本信息里的
    mbl.shipperLine1 = job.copyOnly ? job.shipperLine1 : office.seaAddressLine1
    mbl.shipperLine2 = job.copyOnly ? job.shipperLine2 : office.seaAddressLine2
    mbl.shipperLine3 = job.copyOnly ? job.shipperLine3 : office.seaAddressLine3
    mbl.shipperLine4 = job.copyOnly ? job.shipperLine4 : office.seaAddressLine4
    mbl.shipperLine5 = job.copyOnly ? job.shipperLine5 : office.seaAddressLine5
    mbl.shipperLine6 = job.copyOnly ? job.shipperLine6 : office.seaAddressLine6
    mbl.notifyLine1 = 'SAME AS CONSIGNEE'
    mbl.notifyLine2 = ''
    mbl.notifyLine3 = ''
    mbl.notifyLine4 = ''
    mbl.notifyLine5 = ''
    mbl.notifyLine6 = ''
    mbl.consigneeLine1 = ''
    mbl.consigneeLine2 = ''
    mbl.consigneeLine3 = ''
    mbl.consigneeLine4 = ''
    mbl.consigneeLine5 = ''
    mbl.consigneeLine6 = ''
    if (!LocalStorageUtils.hasConfiguration(key) && !LocalStorageUtils.getConfiguration(key) && !job.copyOnly && job.lob === 'SE') {
      await SeaCargoDoc.copyInfoFromSeaExportJob(job, mbl)
    }
  }

  /**
   * 初始化新增HBL时的相关属性
   */
  static async initHBLProperties(hbl, job = null) {
    if (!job) return
    const key = 'COPY_HBL_' + job.lob
    if (!LocalStorageUtils.hasConfiguration(key) || Boolean(LocalStorageUtils.getConfiguration(key)) || !job.copyOnly) {
      if (job.lob === 'SE') {
        if (job.cargoDoc && job.cargoDoc.length > 0) {
          for (const doc of job.cargoDoc) {
            if (doc.docType === 'HBL') {
              return
            }
          }
        }
        await SeaCargoDoc.copyInfoFromSeaExportJob(job, hbl)
      }
      if (job.lob === 'SI') {
        await SeaImCargoDoc.copyInfoFromSeaImportJob(job, hbl)
      }
    }
  }

  /**
   * 根据目的港代理信息更新MBL，HBL信息
   */
  static async checkOverseaAgentProperties(job, isDo = false) {
    this.currentJob = job
    if (job.destinationAgent && (job.jobState !== -1 || isDo)) {
      const destinationAgent = await Company.getCompanyById(job.destinationAgent)
      if (destinationAgent) {
        await new Company(destinationAgent).getOverseaAgentDetail()
        if (!job.mblOnly) {
          const mblDoc = await new Job(job).getCargoDocByDocType(CargoDocConsts.MBL, job.signMBL)
          if (mblDoc) {
            if (!destinationAgent.overseaAgentDetail) return
            mblDoc.consigneeCode = ''
            mblDoc.consigneeLine1 = destinationAgent.overseaAgentDetail.blAddress
            mblDoc.consigneeLine2 = destinationAgent.overseaAgentDetail.blAddressLine2
            mblDoc.consigneeLine3 = destinationAgent.overseaAgentDetail.blAddressLine3
            mblDoc.consigneeLine4 = destinationAgent.overseaAgentDetail.blAddressLine4
            mblDoc.consigneeLine5 = destinationAgent.overseaAgentDetail.blAddressLine5
            mblDoc.consigneeLine6 = destinationAgent.overseaAgentDetail.blAddressLine6
            mblDoc.consigneeLine7 = destinationAgent.overseaAgentDetail.blAddressLine7
            mblDoc.notifyCode = ''
            if (destinationAgent.overseaAgentDetail.blNotifyAddressLine1 ||
                destinationAgent.overseaAgentDetail.blNotifyAddressLine2 ||
                destinationAgent.overseaAgentDetail.blNotifyAddressLine3 ||
                destinationAgent.overseaAgentDetail.blNotifyAddressLine4 ||
                destinationAgent.overseaAgentDetail.blNotifyAddressLine5 ||
                destinationAgent.overseaAgentDetail.blNotifyAddressLine6 ||
                destinationAgent.overseaAgentDetail.blNotifyAddressLine7) {
              mblDoc.notifyLine1 = destinationAgent.overseaAgentDetail.blNotifyAddressLine1
              mblDoc.notifyLine2 = destinationAgent.overseaAgentDetail.blNotifyAddressLine2
              mblDoc.notifyLine3 = destinationAgent.overseaAgentDetail.blNotifyAddressLine3
              mblDoc.notifyLine4 = destinationAgent.overseaAgentDetail.blNotifyAddressLine4
              mblDoc.notifyLine5 = destinationAgent.overseaAgentDetail.blNotifyAddressLine5
              mblDoc.notifyLine6 = destinationAgent.overseaAgentDetail.blNotifyAddressLine6
              mblDoc.notifyLine7 = destinationAgent.overseaAgentDetail.blNotifyAddressLine7
            }
          }
        }
        await this.changeHBLAgentParty(job, isDo)
      }
    }
  }

  /**
   * 现状：指定货业务，当只录入“指定货代理”时，HBL的代理信息为空；当录入“目的港代理”时，HBL的代理信息会取 “指定货代理”的信息。
   * 实际业务场景：指定货代理是指定货业务实际的委托单位，HBL上的代理信息应该以目的港代理为准。
   * 要求：HBL代理信息的取值，不区分揽货类型，都带入“目的港代理”的提单信息
   * HBL的代理信息应取“目的港代理”对应的信息
   *
   * CARGO-7299 调整为：HBL页签提单代理信息栏位，当业务是指定货时，取指定货代理信息；当业务是自揽货时，取目的港代理信息
   */
  static async changeHBLAgentParty(job, isDo = false) {
    // CARGO-42047 有换单代理的情况下，就不根据目的港代理和指定货代理，带出代理信息了
    const isSc = job.cargoSource === CargoSource.SC_CARGO_SOURCE.code // 是否自揽货
    if (job.exChangeAgent && Number(job.exChangeAgent) > 0 && isSc) {
      return
    }
    this.currentJob = job
    const agentId = !isSc ? job.designationAgent : job.destinationAgent
    if (agentId > 0 && (job.jobState !== -1 || isDo)) {
      const destinationAgent = await Company.getCompanyById(agentId)
      if (destinationAgent) {
        await new Company(destinationAgent).getOverseaAgentDetail()
        if (!isSc) { // 指定货
          const hblDoc = await new Job(job).getCargoDocByDocType(CargoDocConsts.HBL, job.signHBL)
          if (hblDoc) {
            if (!destinationAgent.overseaAgentDetail) return
            hblDoc.agentPartyLine1 = destinationAgent.overseaAgentDetail.blAddress
            hblDoc.agentPartyLine2 = destinationAgent.overseaAgentDetail.blAddressLine2
            hblDoc.agentPartyLine3 = destinationAgent.overseaAgentDetail.blAddressLine3
            hblDoc.agentPartyLine4 = destinationAgent.overseaAgentDetail.blAddressLine4
            hblDoc.agentPartyLine5 = destinationAgent.overseaAgentDetail.blAddressLine5
            hblDoc.agentPartyLine6 = destinationAgent.overseaAgentDetail.blAddressLine6
            hblDoc.agentPartyLine7 = destinationAgent.overseaAgentDetail.blAddressLine7
          }
        } else { // 自揽货
          const hblDocs = await new Job(job).getCargoDoc() || []
          if (hblDocs.length > 0) {
            for (const hblDoc of hblDocs) {
              if (hblDoc.docType !== CargoDocConsts.HBL && hblDoc.docType !== CargoDocConsts.HBL2) {
                continue
              }
              if (destinationAgent.overseaAgentDetail) {
                hblDoc.agentPartyLine1 = destinationAgent.overseaAgentDetail.blAddress
                hblDoc.agentPartyLine2 = destinationAgent.overseaAgentDetail.blAddressLine2
                hblDoc.agentPartyLine3 = destinationAgent.overseaAgentDetail.blAddressLine3
                hblDoc.agentPartyLine4 = destinationAgent.overseaAgentDetail.blAddressLine4
                hblDoc.agentPartyLine5 = destinationAgent.overseaAgentDetail.blAddressLine5
                hblDoc.agentPartyLine6 = destinationAgent.overseaAgentDetail.blAddressLine6
                hblDoc.agentPartyLine7 = destinationAgent.overseaAgentDetail.blAddressLine7
              } else {
                hblDoc.agentPartyLine1 = ''
                hblDoc.agentPartyLine2 = ''
                hblDoc.agentPartyLine3 = ''
                hblDoc.agentPartyLine4 = ''
                hblDoc.agentPartyLine5 = ''
                hblDoc.agentPartyLine6 = ''
                hblDoc.agentPartyLine7 = ''
              }
            }
          }
        }
      }
    }
  }

  /**
   * CARGO-42047 交叉委托的业务，被委托公司需要同步目的港代理/指定货代理信息给到委托公司
   */
  static async changeHBLAndHBL2AgentParty(job) {
    if (job.jobState === -1) return
    const agentId = job.exChangeAgent
    let exChangeAgent = null
    if (agentId > 0) {
      exChangeAgent = await getExChangeAgent({ cmpIdx: agentId, branchId: $store.getters.currentOfficeId }).then(res => {
        return res.data
      })
    } else {
      if (job.designationAgent && Number(job.designationAgent) > 0) {
        await this.changeHBLAgentParty(job, false)
        return
      }
    }
    const hblDocs = await new Job(job).getCargoDoc() || []
    if (hblDocs.length > 0) {
      for (const hblDoc of hblDocs) {
        if (hblDoc.docType !== CargoDocConsts.HBL && hblDoc.docType !== CargoDocConsts.HBL2) {
          continue
        }
        if (exChangeAgent) {
          hblDoc.agentPartyLine1 = exChangeAgent.addressLine1
          hblDoc.agentPartyLine2 = exChangeAgent.addressLine2
          hblDoc.agentPartyLine3 = exChangeAgent.addressLine3
          hblDoc.agentPartyLine4 = exChangeAgent.addressLine4
          hblDoc.agentPartyLine5 = exChangeAgent.addressLine5
          hblDoc.agentPartyLine6 = exChangeAgent.addressLine6
          hblDoc.agentPartyLine7 = exChangeAgent.addressLine7
        } else {
          hblDoc.agentPartyLine1 = ''
          hblDoc.agentPartyLine2 = ''
          hblDoc.agentPartyLine3 = ''
          hblDoc.agentPartyLine4 = ''
          hblDoc.agentPartyLine5 = ''
          hblDoc.agentPartyLine6 = ''
          hblDoc.agentPartyLine7 = ''
        }
      }
    }
  }

  /**
   * 发货人
   */
  static copyBasicShipper(cargoDoc, source) {
    if (!StrUtils.isEmpty(source.shipperLine1) ||
      !StrUtils.isEmpty(source.shipperLine2) ||
      !StrUtils.isEmpty(source.shipperLine3) ||
      !StrUtils.isEmpty(source.shipperLine4) ||
      !StrUtils.isEmpty(source.shipperLine5) ||
      !StrUtils.isEmpty(source.shipperLine6) ||
      !StrUtils.isEmpty(source.shipperLine7)) {
      cargoDoc.shipperCode = source.shipperCode
      cargoDoc.shipperLine1 = source.shipperLine1
      cargoDoc.shipperLine2 = source.shipperLine2
      cargoDoc.shipperLine3 = source.shipperLine3
      cargoDoc.shipperLine4 = source.shipperLine4
      cargoDoc.shipperLine5 = source.shipperLine5
      cargoDoc.shipperLine6 = source.shipperLine6
      cargoDoc.shipperLine7 = source.shipperLine7
    }
  }
  /**
   * 收货人
   */
  static copyBasicConsignee(cargoDoc, source) {
    if (!StrUtils.isEmpty(source.consigneeLine1) ||
      !StrUtils.isEmpty(source.consigneeLine2) ||
      !StrUtils.isEmpty(source.consigneeLine3) ||
      !StrUtils.isEmpty(source.consigneeLine4) ||
      !StrUtils.isEmpty(source.consigneeLine5) ||
      !StrUtils.isEmpty(source.consigneeLine6) ||
      !StrUtils.isEmpty(source.consigneeLine7)) {
      cargoDoc.consigneeCode = source.consigneeCode
      cargoDoc.consigneeLine1 = source.consigneeLine1
      cargoDoc.consigneeLine2 = source.consigneeLine2
      cargoDoc.consigneeLine3 = source.consigneeLine3
      cargoDoc.consigneeLine4 = source.consigneeLine4
      cargoDoc.consigneeLine5 = source.consigneeLine5
      cargoDoc.consigneeLine6 = source.consigneeLine6
      cargoDoc.consigneeLine7 = source.consigneeLine7
    }
  }

  /**
   * 通知人
   */
  static copyBasicNotify(cargoDoc, source) {
    if (!StrUtils.isEmpty(source.notifyLine1) ||
      !StrUtils.isEmpty(source.notifyLine2) ||
      !StrUtils.isEmpty(source.notifyLine3) ||
      !StrUtils.isEmpty(source.notifyLine4) ||
      !StrUtils.isEmpty(source.notifyLine5) ||
      !StrUtils.isEmpty(source.notifyLine6) ||
      !StrUtils.isEmpty(source.notifyLine7)) {
      cargoDoc.notifyCode = source.notifyCode
      cargoDoc.notifyLine1 = source.notifyLine1
      cargoDoc.notifyLine2 = source.notifyLine2
      cargoDoc.notifyLine3 = source.notifyLine3
      cargoDoc.notifyLine4 = source.notifyLine4
      cargoDoc.notifyLine5 = source.notifyLine5
      cargoDoc.notifyLine6 = source.notifyLine6
      cargoDoc.notifyLine7 = source.notifyLine7
    }
  }
  /**
   * 通知人2
   */
  static copyBasicNotify2(cargoDoc, source) {
    if ((!StrUtils.isEmpty(source.notifyLine1) ||
      !StrUtils.isEmpty(source.notifyLine2) ||
      !StrUtils.isEmpty(source.notifyLine3) ||
      !StrUtils.isEmpty(source.notifyLine4) ||
      !StrUtils.isEmpty(source.notifyLine5) ||
      !StrUtils.isEmpty(source.notifyLine6) ||
      !StrUtils.isEmpty(source.notifyLine7)) && source.mblOnly) {
      cargoDoc.notifyCode = source.notifyCode
      cargoDoc.notifyLine1 = source.notifyLine1
      cargoDoc.notifyLine2 = source.notifyLine2
      cargoDoc.notifyLine3 = source.notifyLine3
      cargoDoc.notifyLine4 = source.notifyLine4
      cargoDoc.notifyLine5 = source.notifyLine5
      cargoDoc.notifyLine6 = source.notifyLine6
      cargoDoc.notifyLine7 = source.notifyLine7
    }
    if (!source.mblOnly) {
      cargoDoc.notifyLine1 = 'SAME AS CONSIGNEE'
    }
  }

  static checkBill(isCostControlled, isControlled, t) {
    let result = false
    switch (t) {
      case 'F': // 应付
        if (isControlled) {
          result = true
        }
        break
      case 'S': // 应收
        if (isCostControlled) {
          result = true
        }
        break
      case 'N':
        result = true
        break
      case 'ALL':
        if (isCostControlled && isControlled) {
          result = true
        }
        break
    }
    return result
  }

  static async copyInfoForDoc(job, doc) {
    if (doc.state > 1) return
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    // 提单起运港
    if (job.loadingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
      if (ports.length > 0) {
        doc.loadingPort = ports[0].englishName
      }
    }
    // 提单卸货港
    if (job.dischargingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.dischargingPortCode)
      if (ports.length > 0) {
        doc.dischargingPort = ports[0].englishName
      }
    }
    // 提单交货地
    if (job.destinationPortCode) {
      const ports = seaPorts.filter(p => p.code === job.destinationPortCode)
      if (ports.length > 0) {
        doc.destinationPort = ports[0].englishName
      }
    }
  }

  // 判断收发货人是否有值
  static hasSFContent(source) {
    return (!StrUtils.isEmpty(source.shipperLine1) ||
        !StrUtils.isEmpty(source.shipperLine2) ||
        !StrUtils.isEmpty(source.shipperLine3) ||
        !StrUtils.isEmpty(source.shipperLine4) ||
        !StrUtils.isEmpty(source.shipperLine5) ||
        !StrUtils.isEmpty(source.shipperLine6) ||
        !StrUtils.isEmpty(source.shipperLine7) ||
        !StrUtils.isEmpty(source.consigneeLine1) ||
        !StrUtils.isEmpty(source.consigneeLine2) ||
        !StrUtils.isEmpty(source.consigneeLine3) ||
        !StrUtils.isEmpty(source.consigneeLine4) ||
        !StrUtils.isEmpty(source.consigneeLine5) ||
        !StrUtils.isEmpty(source.consigneeLine6) ||
        !StrUtils.isEmpty(source.consigneeLine7))
  }
  static setVoyageFlight(data) {
    if (data.vessel && data.voyageFlight) {
      return data.vessel + '/' + data.voyageFlight
    } else if (data.vessel) {
      return data.vessel
    } else if (data.voyageFlight) {
      return data.voyageFlight
    } else {
      return ''
    }
  }
  static setSoNo(data) {
    let v = data.soNo
    if (data.soNo && data.soNo.indexOf('\n') !== -1) {
      const n = data.soNo.split('\n')
      v = n[0] + '...'
    }
    return v
  }
  static setFieldHandler(data) {
    data.voyageFlightStr = this.setVoyageFlight(data)
    data.soNoStr = this.setSoNo(data)
    data.customerChineseName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.customerId, 'chineseName')
    data.customerCnShortName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.customerId, 'cnShortName')
    data.customerShortName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.customerId, 'shortName')
    data.bookingAgentChineseName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.bookingAgent, 'chineseName')
    data.bookingAgentCnShortName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.bookingAgent, 'cnShortName')
    data.bookingAgentShortName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.bookingAgent, 'shortName')
    data.carrierChineseName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.carrierId, 'chineseName')
    data.carrierCnShortName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.carrierId, 'cnShortName')
    data.carrierShortName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.carrierId, 'shortName')
    data.destinationAgentChineseName = data.destinationAgent ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.destinationAgent, 'chineseName') : ''
    data.destinationAgentShortName = data.destinationAgent ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.destinationAgent, 'shortName') : ''
    data.designationAgentChineseName = data.designationAgent ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.designationAgent, 'chineseName') : ''
    data.designationAgentShortName = data.designationAgent ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.designationAgent, 'shortName') : ''
  }

  /**
   * 航次截取
   * @param value 原航次
   * @param removeVPoint 是否去除V.或v.
   * @returns {any}
   */
  static replaceVoyage(value, removeVPoint = false) {
    const voyage = (removeVPoint && value && (value.startsWith('V.') || value.startsWith('v.'))) ? value.substring(2) : value
    return voyage
  }

  /**
   * 同步数据，
   * @param sources 数据数组
   * @param target 目标数据
   */
  static syncData(sources, target) {
    if (sources && sources.length > 0) {
      for (const source of sources) {
        if (source.uuid === target.uuid) {
          Object.assign(target, source)
          return
        }
      }
    }
  }
  /**
   * 新增HBL拆单、并单
   * @param hbl2Doc 拆/并单
   * @param job 业务
   * @param hblDoc 提单HBL
   * @returns {Promise<null>}
   */
  static async onAddHbl2CargoDoc(hbl2Doc = null, job = null, hblDoc = null) {
    if (!hbl2Doc) hbl2Doc = new SeaCargoDoc().fillDefaultValue().getData()
    if (!hblDoc) { // 分单不存在时，获取一下HBL数据
      hblDoc = await new SeaExportJob(job).getMainHbl()
    }
    if (!job || !hblDoc) return hbl2Doc
    // 同步业务基本信息
    await SeaCargoDoc.copyInfoFromSeaExportJob(job, hbl2Doc)
    // 关联JoB
    hbl2Doc.jobUuid = job.uuid
    // 提单类型
    hbl2Doc.docType = CargoDocConsts.HBL2
    // 提单状态
    hbl2Doc.state = 1
    // 发货人
    hbl2Doc.shipperLine1 = hblDoc.shipperLine1
    hbl2Doc.shipperLine2 = hblDoc.shipperLine2
    hbl2Doc.shipperLine3 = hblDoc.shipperLine3
    hbl2Doc.shipperLine4 = hblDoc.shipperLine4
    hbl2Doc.shipperLine5 = hblDoc.shipperLine5
    hbl2Doc.shipperLine6 = hblDoc.shipperLine6
    hbl2Doc.shipperLine7 = hblDoc.shipperLine7
    hbl2Doc.shipperCode = hblDoc.shipperCode
    // 收货人
    hbl2Doc.consigneeLine1 = hblDoc.consigneeLine1
    hbl2Doc.consigneeLine2 = hblDoc.consigneeLine2
    hbl2Doc.consigneeLine3 = hblDoc.consigneeLine3
    hbl2Doc.consigneeLine4 = hblDoc.consigneeLine4
    hbl2Doc.consigneeLine5 = hblDoc.consigneeLine5
    hbl2Doc.consigneeLine6 = hblDoc.consigneeLine6
    hbl2Doc.consigneeLine7 = hblDoc.consigneeLine7
    hbl2Doc.consigneeCode = hblDoc.consigneeCode
    // 通知人
    hbl2Doc.notifyLine1 = hblDoc.notifyLine1
    hbl2Doc.notifyLine2 = hblDoc.notifyLine2
    hbl2Doc.notifyLine3 = hblDoc.notifyLine3
    hbl2Doc.notifyLine4 = hblDoc.notifyLine4
    hbl2Doc.notifyLine5 = hblDoc.notifyLine5
    hbl2Doc.notifyLine6 = hblDoc.notifyLine6
    hbl2Doc.notifyLine7 = hblDoc.notifyLine7
    hbl2Doc.notifyCode = hblDoc.notifyCode
    // 代理信息
    hbl2Doc.agentPartyLine1 = hblDoc.agentPartyLine1
    hbl2Doc.agentPartyLine2 = hblDoc.agentPartyLine2
    hbl2Doc.agentPartyLine3 = hblDoc.agentPartyLine3
    hbl2Doc.agentPartyLine4 = hblDoc.agentPartyLine4
    hbl2Doc.agentPartyLine5 = hblDoc.agentPartyLine5
    hbl2Doc.agentPartyLine6 = hblDoc.agentPartyLine6
    hbl2Doc.agentPartyLine7 = hblDoc.agentPartyLine7

    hbl2Doc.alsoNotify = hblDoc.alsoNotify
    hbl2Doc.blNumber = hblDoc.blNumber
    hbl2Doc.quantity = NumberUtils.ToFixed2(job.quantityActual, 2) || 0
    hbl2Doc.weight = NumberUtils.ToFixed2(job.weightActual, 3)
    hbl2Doc.cubage = NumberUtils.ToFixed2(job.cubageActual, 3)
    hbl2Doc.chargeWeight = NumberUtils.ToFixed2(job.chargeWeight, 3)
    hbl2Doc.paymentPlaceBL = hblDoc.paymentPlaceBL
    hbl2Doc.signPlaceBL = hblDoc.signPlaceBL
    hbl2Doc.signDateBL = hblDoc.signDateBL
    // 包装
    hbl2Doc.packing = job.packing
    // 英文品名
    hbl2Doc.cargoEnglishName = hblDoc.cargoEnglishName
    // 唛头
    hbl2Doc.mark = hblDoc.mark
    // 备注
    hbl2Doc.remarks = hblDoc.remarks
    // 提单方式
    hbl2Doc.releaseType = hblDoc.releaseType
    // 运输条款
    if (!hbl2Doc.freightTermHBL && job.freightTermHBL) {
      const shippingTermList = await getSpecificBasicData(basicCacheKeys.basic_data_ShippingTerm)
      if (shippingTermList && shippingTermList.length > 0) {
        const shippingTerm = shippingTermList.find(p => p.code === job.freightTermHBL)
        if (shippingTerm) {
          hbl2Doc.freightTermHBL = shippingTerm.name || ''
        }
      }
    }
    // 拆单时，初始化HBL付款方式
    if (job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
      hbl2Doc.paymentTerm = job.paymentTermHBL || ''
    }
    return hbl2Doc
  }
  // CARGO-32896 整拼类型=自拼箱，每个小票【反恐仓单-MB/L NO】改为取值【主单 -MB/L NO.】
  // 新增AMS,同步HBL信息到ams都调用这个
  static syncMblNo(amsCargoDoc, job) {
    if (!amsCargoDoc || !job) return
    if (job.containerLoadType === 'LCL' && job.lclMasterUuid && job.lclMaster) {
      amsCargoDoc.mbl = amsCargoDoc.mbl || job.lclMaster.mbl
    } else {
      amsCargoDoc.mbl = job.mbl
    }
  }
  // CARGO-33651 利通 反恐舱单-企泰报文取值修改
  // 同步HBL的运输条款到AMS
  static syncFreightTermForAms(amsDoc, hblDoc) {
    if (!amsDoc || !hblDoc || !hblDoc.freightTermHBL) return
    const freightTermList = SystemConstants.AMS_FREIGHT_TERM
    if (freightTermList && freightTermList.length > 0) {
      const shippingTerm = freightTermList.find(p => p.code === hblDoc.freightTermHBL)
      if (shippingTerm) {
        amsDoc.freightTermHBL = shippingTerm.code
      }
    }
  }
  // 校验提单装箱信息与业务装箱信息是否一致
  static async checkDocQWCSame(cargoDocs, containerUsages) {
    const quantityMap = new Map()
    const weightMap = new Map()
    const cubageMap = new Map()
    for (const cargoDoc of cargoDocs) {
      const ediContainers = await new SeaCargoDoc(cargoDoc).getEdiContainer()
      if (!ediContainers || ediContainers.length === 0) {
        continue
      }
      for (const ediContainer of ediContainers) {
        if (ediContainer.deleted) {
          continue
        }
        const key = ediContainer.containerUsageUuid
        const quantity = Number(ediContainer.quantity)
        if (quantity !== 0) {
          quantityMap.set(key, NumberUtils.ToFixed2((quantityMap.get(key) || 0) + quantity, 3))
        }
        const weight = Number(ediContainer.weight)
        if (weight !== 0) {
          weightMap.set(key, NumberUtils.ToFixed2((weightMap.get(key) || 0) + weight, 3))
        }
        const cubage = Number(ediContainer.cubage)
        if (cubage !== 0) {
          cubageMap.set(key, NumberUtils.ToFixed2((cubageMap.get(key) || 0) + cubage, 3))
        }
      }
    }
    for (const containerUsage of containerUsages) {
      if (!containerUsage.uuid || !(containerUsage.quantity > 0 || containerUsage.weight > 0 || containerUsage.cubage > 0)) {
        continue
      }
      const key = containerUsage.uuid
      const quantitySum = quantityMap.get(key) || 0
      const weightSum = weightMap.get(key) || 0
      const cubageSum = cubageMap.get(key) || 0
      if (quantitySum !== Number(containerUsage.quantity) || weightSum !== Number(containerUsage.weight) || cubageSum !== Number(containerUsage.cubage)) {
        Message.warning(lang.t('Message.CargoDocAndContainerQWTNotSame'))
        return
      }
    }
  }

  static async alsoNotifyChange(data) {
    const company = new Company(data)
    await company.getMainfestAddress()
    const ma = data.manifestAddress
    let text = ''
    if (ma) {
      text = this.appendAddressLine(text, ma.addressLine1)
      text = this.appendAddressLine(text, ma.addressLine2)
      text = this.appendAddressLine(text, ma.addressLine3)
      text = this.appendAddressLine(text, ma.addressLine4)
      text = this.appendAddressLine(text, ma.addressLine5)
      text = this.appendAddressLine(text, ma.addressLine6)
      text = this.appendAddressLine(text, ma.addressLine7)
    }
    return text
  }
  static appendAddressLine(text, value) {
    if (value) {
      if (text) {
        text += '\n'
      }
      text += value
    }
    return text
  }

  static shipperAddressFormat(data, field) {
    let result = ''
    result += lang.t('SeaExport.Shipper') + '\n'
    result += lang.t('SeaExport.consignorCode') + ' ' + data.shipperShortCode + '\n'
    result += '+ ' + data.shipperEnterpriseCode + '\n'
    result += lang.t('SeaExport.consignorName') + ' ' + data.shipperEnterpriseName + '\n'
    result += lang.t('SeaExport.consignorDetailAddress') + ' ' + data.shipperAddress + '\n'
    return result + this.sameAddress(data, field)
  }

  static consigneeAddressFormat(data, field) {
    let result = ''
    result += lang.t('SeaExport.Consignee') + '\n'
    result += lang.t('SeaExport.consigneeCode') + ' ' + data.consigneeShortCode + '\n'
    result += '+ ' + data.consigneeEnterpriseCode + '\n'
    result += lang.t('SeaExport.consigneeName') + ' ' + data.consigneeEnterpriseName + '\n'
    result += lang.t('SeaExport.consigneeDetailAddress') + ' ' + data.consigneeAddress + '\n'
    result += this.sameAddress(data, field)
    result += lang.t('SeaExport.specificContactName') + ' ' + data.consigneeSpecificContactsName + '\n'
    let typeName = ''
    switch (data.consigneeSpecificContactsType) {
      case 0:
        typeName = lang.t('SeaExport.specificContactPhone')
        break
      case 1:
        typeName = lang.t('SeaExport.specificContactAddress')
        break
      case 2:
        typeName = lang.t('SeaExport.specificContactRelexNumber')
        break
      default:
        typeName = ''
    }
    result += typeName + ' ' + data.consigneeSpecificContacts
    return result
  }

  static notifyAddressFormat(data, field) {
    let result = ''
    result += lang.t('SeaExport.NotifyParty') + '\n'
    result += lang.t('SeaExport.consignorCode') + ' ' + data.shipperShortCode + '\n'
    result += '+ ' + data.shipperEnterpriseCode + '\n'
    result += lang.t('SeaExport.consignorName') + ' ' + data.shipperEnterpriseName + '\n'
    result += lang.t('SeaExport.consignorDetailAddress') + ' ' + data.shipperAddress + '\n'
    return result + this.sameAddress(data, field)
  }

  static paymentAddressFormat(data, field) {
    let result = ''
    result += lang.t('CargoMsg.Cargo_Payment1') + '\n'
    result += lang.t('CargoMsg.Cargo_PaymentEnterpriseCode') + ' ' + data.paymentShortCode + '\n'
    result += '+ ' + data.paymentEnterpriseCode + '\n'
    result += lang.t('CargoMsg.Cargo_Payment2') + ' ' + data.paymentEnterpriseName + '\n'
    result += lang.t('CargoMsg.Cargo_Payment3') + ' ' + data.paymentAddress + '\n'
    result += this.sameAddress(data, field)
    result += lang.t('SeaExport.specificContactName') + ' ' + data.paymentSpecificContactsName + '\n'
    let typeName = ''
    switch (data.paymentSpecificContactsType) {
      case 0:
        typeName = lang.t('SeaExport.specificContactPhone')
        break
      case 1:
        typeName = lang.t('SeaExport.specificContactAddress')
        break
      case 2:
        typeName = lang.t('SeaExport.specificContactRelexNumber')
        break
      default:
        typeName = ''
    }
    result += typeName + ' ' + data.paymentSpecificContacts
    return result
  }

  static sameAddress(data, field) {
    let result = ''
    const contactsName = this.contactsTypeFormat(data, field)
    result += contactsName + ' ' + data[field + 'Contacts'] + '\n'
    result += lang.t('SeaExport.cityName') + ' ' + data[field + 'CityName'] + '\n'
    result += lang.t('SeaExport.provinceCode') + ' ' + data[field + 'ProvinceCode'] + '\n'
    result += lang.t('SeaExport.provinceName') + ' ' + data[field + 'ProvinceName'] + '\n'
    result += lang.t('SeaExport.ZipCode') + ' ' + data[field + 'ZipCode'] + '\n'
    result += lang.t('CargoMsg.Cargo_CountryRegionCode') + ' ' + data[field + 'CountryCode'] + '\n'
    result += lang.t('SeaExport.aeoEnterpriseCode') + ' ' + data[field + 'AeoEnterpriseCode'] + '\n'
    result += 'EORI' + ' ' + data[field + 'Eori'] + '\n'
    result += lang.t('SeaExport.StreetNumber') + ' ' + data[field + 'StreetNo'] + '\n'
    return result
  }

  static contactsTypeFormat(data, field) {
    const name = field + 'ContactsType'
    if (data[name] === 0) {
      return lang.t('SeaExport.consignorPhone')
    }
    if (data[name] === 1) {
      return lang.t('SeaExport.consignorEmail')
    }
    if (data[name] === 2) {
      return lang.t('SeaExport.consignorRelexNumber')
    }
    return ''
  }

  /**
   * 同步提单的个别字段信息至业务
   * @param job
   * @param cargoDoc
   * @param field
   */
  static async syncBillToJobBySingleField(job = null, cargoDoc = null, field = '') {
    if (!job || !cargoDoc || !field) return
    await cache.load(cacheName.CONFIG)
    const billOfLadingSynMode = cache && cache.config ? parseInt(cache.config.get('BillOfLadingSynMode')) : 0
    if (billOfLadingSynMode === 2) { // 双向同步的时候，修改提单的时候，要同步到业务上
      job[field] = cargoDoc[field]
    }
  }

  static async fillNvoccScacAndEfNvoccScac(cargoDoc) {
    if (!cargoDoc) {
      return
    }
    const currentOfficeId = $store.getters.currentOfficeId
    const office = await Office.getOfficeById(currentOfficeId)
    if (office) {
      if (!StrUtils.isEmpty(office.nvoccScac)) {
        const list = []
        const r = office.nvoccScac.trim().split('\n')
        for (let j = 0; j < r.length; j++) {
          if (r[j]) {
            list.push(r[j])
          }
        }
        if (list.length > 0) {
          if (StrUtils.isEmpty(cargoDoc.nvoccScac)) {
            cargoDoc.nvoccScac = list[0]
          }
          if (StrUtils.isEmpty(cargoDoc.efNvoccScac)) {
            list.sort((a, b) => {
              const aStartsWith8 = a.startsWith('8') ? 0 : 1 // 8开头的优先级高
              const bStartsWith8 = b.startsWith('8') ? 0 : 1
              return aStartsWith8 - bStartsWith8
            })
            cargoDoc.efNvoccScac = list[0]
          }
        }
      }
    }
  }

  /**
   * 同步提单收发通到job
   * @param job
   * @param cargoDoc
   */
  static syncCargoDocSftToJob(job, cargoDoc) {
    if (!job || !cargoDoc) return
    const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(cache.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1
    if (syncCustomerShippingInfoBothBolAndBasicTab && job.jobState !== 1) {
      if ((job.mblOnly && cargoDoc.docType === CargoDocConsts.MBL) || (job.lob === SystemConstants.AE.code && job.operateType === parseInt(AirExportConstants.DIRECT.code) && cargoDoc.docType === CargoDocConsts.MAWB)) {
        new CargoDoc(cargoDoc).syncDocSftToJob(job, true, syncCustomerShippingInfoBothBolAndBasicTab)
        if (job.lob === SystemConstants.SE.code) {
          job.alsoNotify = cargoDoc.alsoNotify
        }
      }
      if ((!job.mblOnly && cargoDoc.docType === CargoDocConsts.HBL) || ((job.lob === SystemConstants.AE.code && job.operateType !== parseInt(AirExportConstants.DIRECT.code) && cargoDoc.docType === CargoDocConsts.HAWB))) {
        new CargoDoc(cargoDoc).syncDocSftToJob(job, true, syncCustomerShippingInfoBothBolAndBasicTab)
        if (job.lob === SystemConstants.SE.code) {
          job.alsoNotify = cargoDoc.alsoNotify
        }
      }
    }
  }

  /**
   * 同步job收发通到提单
   * @param job
   * @param cargoDoc
   * @param isAdd
   */
  static syncJobSftToDoc(job, cargoDoc, isAdd = false) {
    if (!job || !cargoDoc) return
    const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(cache.config.get('SyncCustomerShippingInfoBothBolAndBasicTab'))
    const isAddSync = syncCustomerShippingInfoBothBolAndBasicTab === 2 && isAdd
    if ((syncCustomerShippingInfoBothBolAndBasicTab === 1 || isAddSync) && job.jobState !== 1) {
      if ((job.mblOnly && cargoDoc.docType === CargoDocConsts.MBL) || (job.lob === SystemConstants.AE.code && job.operateType === parseInt(AirExportConstants.DIRECT.code) && cargoDoc.docType === CargoDocConsts.MAWB)) {
        new Job(job).syncJobSftToDoc(cargoDoc, true, syncCustomerShippingInfoBothBolAndBasicTab || isAddSync)
        if (job.lob === SystemConstants.SE.code) {
          cargoDoc.alsoNotify = job.alsoNotify
        }
      }
      if ((!job.mblOnly && cargoDoc.docType === CargoDocConsts.HBL) || ((job.lob === SystemConstants.AE.code && job.operateType !== parseInt(AirExportConstants.DIRECT.code) && cargoDoc.docType === CargoDocConsts.HAWB))) {
        new Job(job).syncJobSftToDoc(cargoDoc, true, syncCustomerShippingInfoBothBolAndBasicTab || isAddSync)
        if (job.lob === SystemConstants.SE.code) {
          cargoDoc.alsoNotify = job.alsoNotify
        }
      }
    }
  }
}
